import { useEffect, useState } from "react";
import { useNavigate, Outlet, Link, useLocation } from "react-router-dom";
import { supabase } from "../../lib/supabase";

export default function AdminLayout() {
  const [loading, setLoading] = useState(true);
  const [admin, setAdmin] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const checkAdmin = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      
      if (!session) {
        navigate("/acesso-interno-bt");
        return;
      }

      const { data: adminData, error } = await supabase
        .from("admins")
        .select("*")
        .eq("user_id", session.user.id)
        .single();

      if (error || !adminData) {
        await supabase.auth.signOut();
        navigate("/acesso-interno-bt");
        return;
      }

      setAdmin(adminData);
      setLoading(false);
    };

    checkAdmin();

    // Escutar mudancas de autenticacao
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
      if (event === "SIGNED_OUT") {
        navigate("/acesso-interno-bt");
      }
    });

    return () => subscription.unsubscribe();
  }, [navigate]);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate("/acesso-interno-bt");
  };

  if (loading) {
    return (
      <div style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f5f5f5"
      }}>
        <p>Carregando...</p>
      </div>
    );
  }

  const menuItems = [
    { path: "/acesso-interno-bt/painel", label: "Dashboard" },
    { path: "/acesso-interno-bt/empresas", label: "Empresas" },
    { path: "/acesso-interno-bt/avaliacoes", label: "Avaliacoes" },
    { path: "/acesso-interno-bt/vagas", label: "Vagas" },
    { path: "/acesso-interno-bt/mulheres", label: "Mulheres" },
    { path: "/acesso-interno-bt/logs", label: "Logs" },
  ];

  return (
    <div style={{ display: "flex", minHeight: "100vh", backgroundColor: "#f5f5f5" }}>
      {/* Sidebar */}
      <aside style={{
        width: "240px",
        backgroundColor: "#1f2937",
        color: "#fff",
        padding: "1.5rem 0",
        display: "flex",
        flexDirection: "column"
      }}>
        <div style={{ padding: "0 1.5rem", marginBottom: "2rem" }}>
          <h2 style={{ fontSize: "1.25rem", fontWeight: "600" }}>Admin</h2>
          <p style={{ fontSize: "0.75rem", color: "#9ca3af", marginTop: "0.25rem" }}>
            {admin?.email}
          </p>
        </div>

        <nav style={{ flex: 1 }}>
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              style={{
                display: "block",
                padding: "0.75rem 1.5rem",
                color: location.pathname === item.path ? "#fff" : "#9ca3af",
                backgroundColor: location.pathname === item.path ? "#374151" : "transparent",
                textDecoration: "none",
                fontSize: "0.875rem",
                borderLeft: location.pathname === item.path ? "3px solid #3b82f6" : "3px solid transparent"
              }}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div style={{ padding: "0 1.5rem" }}>
          <button
            onClick={handleLogout}
            style={{
              width: "100%",
              padding: "0.75rem",
              backgroundColor: "#dc2626",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "0.875rem"
            }}
          >
            Sair
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main style={{ flex: 1, padding: "2rem", overflowY: "auto" }}>
        <Outlet context={{ admin }} />
      </main>
    </div>
  );
}
